// Azure Table Storage Service
const AZURE_CONFIG = {
  storageAccount: "mfprojects", // Dein Storage Account Name
  tableName: "projectBudget",
  sasToken:
    "sv=2024-11-04&ss=t&srt=sco&sp=rwdlacu&se=2035-07-04T17:08:25Z&st=2025-07-04T09:08:25Z&spr=https&sig=X7s%2BFIyYcKvRzSxRNAp5BUJEe2YUcg8nojkn9fIfcTY%3D",
};

// Budget für alle Projekte laden
export const getProjectBudgets = async () => {
  try {
    let allEntries = [];
    let nextPartitionKey = null;
    let nextRowKey = null;

    do {
      let url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}?${AZURE_CONFIG.sasToken}`;

      if (nextPartitionKey && nextRowKey) {
        url += `&NextPartitionKey=${encodeURIComponent(nextPartitionKey)}`;
        url += `&NextRowKey=${encodeURIComponent(nextRowKey)}`;
      }

      const response = await fetch(url, {
        headers: { Accept: "application/json;odata=nometadata" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Azure Table Error: ${response.status}`);
      }

      const data = await response.json();
      allEntries = allEntries.concat(data.value || []);

      nextPartitionKey = response.headers.get(
        "x-ms-continuation-NextPartitionKey"
      );
      nextRowKey = response.headers.get("x-ms-continuation-NextRowKey");
    } while (nextPartitionKey && nextRowKey);

    const budgets = {};
    allEntries.forEach((item) => {
      budgets[item.RowKey] = item.budget || 0;
    });

    return budgets;
  } catch (error) {
    return {};
  }
};

// Budget für ein einzelnes Projekt updaten
export const updateProjectBudget = async (projectNumber, budget) => {
  try {
    const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}(PartitionKey='projects',RowKey='${projectNumber}')?${AZURE_CONFIG.sasToken}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json;odata=nometadata",
      },
      body: JSON.stringify({
        PartitionKey: "projects",
        RowKey: projectNumber,
        budget: budget,
        UpdatedAt: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error(`Azure Update Error: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("Fehler beim Speichern des Budgets:", error);
    throw error;
  }
};
